import React, {useEffect} from "react";
import UserManagerPage from "./UserManagerPage";
import {useRouteMatch} from "react-router";
import {useMutation, useQuery} from "@apollo/client";
import {useHistory} from "react-router-dom";
import {IonButton, IonInput, IonItem, IonLoading, IonSelect, IonSelectOption} from "@ionic/react";
import {
    USER_GET_ROLE_DATA_QUERY,
    USER_GET_RULES_QUERY, USER_MANAGER_UPDATE_ROLE,
    USER_MANAGER_UPDATE_ROLE_ADD_RULE,
    USER_MANAGER_UPDATE_ROLE_REMOVE_RULE
} from "../../schemas/userManager";



const UserManagerEditRole: React.FC<any> = () => {

    const history = useHistory();
    const match:any = useRouteMatch();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [roleId, setRoleId] = React.useState<number | undefined>(undefined);
    const [selectedRuleId, setSelectedRuleId] = React.useState<number | undefined>(undefined);
    const [details, setDetails] = React.useState<string | undefined | null>(undefined);
    const [color, setColor] = React.useState<string | undefined | readonly string[] | number>(undefined);
    const {loading:roleLoading, error:roleError, data: roleData, refetch} = useQuery(USER_GET_ROLE_DATA_QUERY, {variables: {id: roleId}});
    const {loading:rulesLoading, error:rulesError, data: rulesData} = useQuery(USER_GET_RULES_QUERY, {variables: {}});

    const [removeRuleMutation] = useMutation(USER_MANAGER_UPDATE_ROLE_REMOVE_RULE);
    const [addRuleMutation] = useMutation(USER_MANAGER_UPDATE_ROLE_ADD_RULE);
    const [updateRoleMutation] = useMutation(USER_MANAGER_UPDATE_ROLE);


    useEffect(() => {
        if (roleData) {
            setDetails(roleData.getRoleData.details);
            setColor(roleData.getRoleData.color);
        }
    }, [roleData]);

    useEffect(() => {
        setIsLoading(roleLoading);
    }, [roleLoading]);

    useEffect(() => {
        setRoleId(Number(match.params.id));
    }, []);


    const removeRule = async (ruleId: number) => {
        if (window.confirm('Are you sure you want to remove this rule?')) {
            const results = await removeRuleMutation({variables: {data: {ruleId: ruleId, roleId: roleId}}});
            await refetch();
        }
    };
    const addRule = async (ruleId: number)=> {
        const results = await addRuleMutation({variables: {data: {ruleId: ruleId, roleId: roleId}}});
        await refetch();
        setSelectedRuleId(undefined);
    };

    const updateRole = async () => {
        setIsLoading(true);
        await updateRoleMutation({variables: {data: {id: roleId, details: details, color: color}}});
        await refetch();
    };


    return (
        <UserManagerPage page={'edit-role'}>
            <IonLoading isOpen={roleLoading} />
            {!roleLoading && roleData && roleData.getRoleData &&

                <div className="userManagerContent">
                    <h1>Edit Role: {roleData.getRoleData.name}</h1>
                    <div style={{backgroundColor: "white", padding: "10px"}}>
                        <h3>Role Information</h3>
                        <p>Update the information on the role here:</p>
                        <div style={{display: "table", borderCollapse: "separate", borderSpacing: "10px"}}>
                            <div style={{display: "table-row"}}>
                                <div style={{display: "table-cell"}}>
                                    <b>Details:</b>
                                </div>
                                <div style={{display: "table-cell"}}>
                                    <IonItem>
                                        <IonInput value={details} onIonChange={(e) => setDetails(e.detail.value)}></IonInput>
                                    </IonItem>
                                </div>
                                <div style={{display: "table-cell"}}>

                                </div>
                            </div>
                            <div style={{display: "table-row"}}>
                                <div style={{display: "table-cell"}}>
                                    <b>Color:</b>
                                </div>
                                <div style={{display: "table-cell"}}>
                                    <IonItem>
                                        <input type="color" value={color} onChange={(e) => setColor(e.currentTarget.value)}></input>
                                    </IonItem>
                                </div>
                                <div style={{display: "table-cell"}}>
                                    <div style={{
                                        width: '10px',
                                        height: '10px',
                                        backgroundColor: roleData.getRoleData.color,
                                        border: '1px solid black'
                                    }}></div>
                                </div>
                            </div>
                        </div>
                        <p style={{textAlign: "right"}}>
                            <IonButton fill="outline" onClick={() => history.goBack()}>Go Back</IonButton>
                            <IonButton onClick={() => updateRole()}>Update Role</IonButton>
                        </p>

                        <h3>Rules</h3>

                        <p>Update the rules this role contains. Updates are instant.</p>
                        {roleData.getRoleData.role_rules && roleData.getRoleData.role_rules.map((role_rule: any) => {

                            return (
                                <div key={'rule_' + role_rule.rules.name} className="badge" style={{
                                    float: 'left',
                                    backgroundColor: '#3880ff',
                                    display: 'inline-block',
                                    margin: '5px',
                                    padding: '5px 10px 5px 10px'
                                }}>
                                    {role_rule.rules.name}
                                    <button style={{
                                        marginLeft: '5px',
                                        backgroundColor: 'transparent'
                                    }} onClick={() => removeRule(role_rule.rules.id)}>X
                                    </button>

                                </div>
                            )
                        })}

                        <div style={{clear: 'both'}}></div>
                        <div style={{margin: '5px', border: '1px solid grey', borderRadius: '5px', padding: '10px'}}>

                            <IonSelect label="Add Rule" labelPlacement="floating" value={null} onIonChange={(e) => addRule(e.detail.value)}>
                                {rulesData && rulesData.getRules.map((rule: any) => {
                                    let found = false;
                                    roleData.getRoleData.role_rules.forEach((role_rule: any) => {
                                        if (rule.id === role_rule.rule_id) {
                                            found = true;
                                        }
                                    })
                                    if (!found) {
                                        return (
                                            <IonSelectOption value={rule.id} key={'rule_' + rule.id}>{rule.name}</IonSelectOption>
                                        );
                                    }
                                })}
                            </IonSelect>

                        </div>

                    </div>
                </div>
            }
        </UserManagerPage>
    );
};


export default UserManagerEditRole;